<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="surgery-list"
            :url="url"
            :columns="columnList"
            :defaultSort="defaultSort"
            :buttons="buttons"
            :tableHeight="tableHeight - 30"
            :addButton="{ enabled: false }"
            :updateButton="{ enabled: false }"
            :searchLocal="false"
            @loadAnesthesiaIndex="loadAnesthesiaIndex"
            @loadRecovery="loadRecovery"
            @loadMergedPatientData="loadMergedPatientData"
            @loadReoperation="loadReoperation"
            @loadRestartOperation="loadRestartOperation"
            @print="print"
            @rowDbclick="rowDbclick"
            :columnConfig="true"
            @loadSurgeryCancel="loadSurgeryCancel"
        >
            <template slot="filter">
                <el-col :md="8" :xl="5">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input
                        type="string"
                        class="margin5 margin-none-h"
                        v-model="searchKey2"
                        :autofocus="true"
                        :placeholder="getPlaceholder"
                        :clearable="true"
                        @keyup.native.enter="loadSurgeries2"
                    ></item-input>
                </el-col>
                <el-col :md="8" :lg="5" :xl="5">
                    <item-input type="multiselect" v-model="surgery_status" :isShowCheckedAll="true" :options="sys_enums && sys_enums.SurgeryStatus" :clearable="true" placeholder="手术状态"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input type="multiselect" v-model="dic_room_ids" :isShowCheckedAll="true" :options="operationRoom" :clearable="true" placeholder="手术间"></item-input>
                </el-col>
                <el-col :span="4"> &nbsp;<item-input type="checkbox" v-model="is_own" style="display: inline-block; width: 50px">我的患者</item-input> </el-col>
            </template>
            <span slot="push_status" slot-scope="{ row }">
                <i v-if="row.push_status == 1" class="el-icon-circle-check fg-primary"> </i>
                <i v-else-if="row.push_status == 2" class="el-icon-circle-check-outline fg-warning" :title="row.push_status_msg"></i>
                <i v-else-if="row.push_status == 3" class="el-icon-circle-close fg-danger" :title="row.push_status_msg"></i>
                <i v-else> </i>
            </span>
            <template slot="filter-after">

                <el-button type="primary" size="mini" @click="refreshList" title="查询">查询<i class="el-icon--right"></i></el-button>
                <el-button type="primary" size="mini" @click="loadOperationRoom" v-if="isDesktop && isSelectVisitType == `1`">创建手术</el-button>
                <el-button type="primary" size="mini" @click="loadOperationRoom" v-if="isDesktop && (!isSelectVisitType || isSelectVisitType != `1`)">创建急诊手术</el-button>
                <el-button type="primary" size="mini" @click="loadAnesTemplateList" title="导出空模板">导出空模板<i class="el-icon--right"></i></el-button>
                <el-button v-show="anesthsiaListExportConfig" type="primary" size="mini" @click="ExportExcel">导出<i class="el-icon--right"></i></el-button>
            </template>
            <template slot="patient_info" slot-scope="{ row }">
                <el-row>
                    <el-col :span="1" class="height-p100">
                        <div
                            class="surgery-status-tag"
                            :title="row.surgery_status"
                            :style="{ height: `90px` }"
                            :class="row.enum_surgery_status == 30 ? 'bg-danger' : row.enum_surgery_status == 20 || row.enum_surgery_status == 10 ? 'bg-primary' : 'bg-info'"
                        >
                            &nbsp;<br />&nbsp;
                        </div>
                    </el-col>
                    <el-col :span="23" class="padding5 padding-none-v align-left" :title="titleLabel(row)">
                        <div class="ellipsis" :title="`${row.patient_name}(${row.sex || '--'}/${row.age || '--'}/${row.visit_no || '--'}/${row.outpatient_no || '--'}/${row.bed_no || '--'}床)`">
                            <b>
                                <span class="circle fg-red borderd" v-if="row.is_reoperation">再</span>
                                {{ `${row.patient_name}(${row.sex || '--'}/${row.age || '--'}/${row.visit_no || '--'}/${row.outpatient_no || '--'}/${row.bed_no || '--'}床)` }}
                            </b>
                        </div>
                        <div>
                            <b class="ellipsis">{{ row.surgeries }}</b>
                        </div>
                        <div v-if="!proc_GetTipItemsAnesthsia || proc_GetTipItemsAnesthsia == '0' || proc_GetTipItemsAnesthsia == ''">
                            <el-tag
                                :style="{ color: row.enum_surgery_type > 1 ? '#2A918A' : '#F56C6C', borderColor: row.enum_surgery_type > 1 ? '#2A918A' : '#F56C6C', backgroundColor: 'white' }"
                                size="mini"
                                >{{ row.surgery_type }}</el-tag
                            >
                            <!-- <el-tag style="color: #f56c6c; border-color: #f56c6c; background-color: white" size="mini" v-if="row.enum_surgery_type">{{ row.surgery_type }}</el-tag> -->
                            <el-tag
                                :style="{ color: row.enum_surgery_status >= 40 ? '#DFE2E7' : '#52b8d2', borderColor: row.enum_surgery_status == 40 ? '#DFE2E7' : '#52b8d2', backgroundColor: 'white' }"
                                size="mini"
                                >{{ row.enum_surgery_status > 10 ? '已排' : '待排' }}</el-tag
                            >
                            <el-tag style="color: #a0bb31; border-color: #a0bb31; background-color: white" size="mini">{{
                                row.enum_visit_type == 1 ? '住院' : row.enum_visit_type == 2 ? '门诊' : '体检'
                            }}</el-tag>
                            <el-tag :style="{ color: row.is_day_surgery ? '#6CBE5E' : '#DFE2E7', borderColor: row.is_day_surgery ? '#6CBE5E' : '#DFE2E7', backgroundColor: 'white' }" size="mini"
                                >日间</el-tag
                            >
                            <el-tag :style="{ color: row.is_endoscopy ? '#f2b04b' : '#DFE2E7', borderColor: row.is_endoscopy ? '#f2b04b' : '#DFE2E7', backgroundColor: 'white' }" size="mini"
                                >内镜</el-tag
                            >
                            <el-tag :style="{ color: row.is_local_anes ? '#5AA7B0' : '#DFE2E7', borderColor: row.is_local_anes ? '#5AA7B0' : '#DFE2E7', backgroundColor: 'white' }" size="mini"
                                >局麻</el-tag
                            >
                        </div>
                        <div v-else>
                            <el-tag v-for="item in row.patientInfoTipItemsList" :index="item.label" :key="item.label" :style="item.style" size="mini">{{ item.label }}</el-tag>
                        </div>
                    </el-col>
                </el-row>
            </template>
            <div slot="anes_is_print" class="ellipsis" slot-scope="{ row }">
                <div
                    style="white-space: normal"
                    :style="row.anes_is_print=='是'? 'background-color:rgb(95, 219, 101)' :'background-color:rgb(74, 112, 187)'"
                >
                    {{ row.anes_is_print=='是'? '是':'否'}}
                </div>
            </div>
            <template slot="diseases" slot-scope="{ row }">
                <div style="width: 180px; white-space: normal">
                    <span>{{ row.diseases }}</span>
                </div>
            </template>
            <template slot="surgeon" slot-scope="{ row }">
                <div style="width: 90px; white-space: normal">
                    (主)<span>{{ row.surgeon }}</span>
                </div>
                <div class="fg-info">
                    <span>{{ row.surgeon_assistants }}</span>
                </div>
            </template>
            <template slot="plan_anes_doctor" slot-scope="{ row }">
                <div style="width: 90px; white-space: normal">
                    (主)<span>{{ row.plan_anes_doctor }}</span>
                </div>
                <div class="fg-info">
                    <span>{{ row.plan_anes_assistants && row.plan_anes_assistants.toString() }}</span>
                </div>
            </template>
            <template slot="anaes_methods" slot-scope="{ row }"
                ><div style="width: 100px; white-space: normal">
                    <span>{{ row.anaes_methods }}</span>
                </div></template
            >
            <template slot="dic_section" slot-scope="{ row }"
                ><div style="width: 100px; white-space: normal">
                    <span>{{ row.dic_section }}</span>
                </div></template
            >
            <template slot="plan_circuit_nurse" slot-scope="{ row }"
                ><div style="width: 60px; white-space: normal">
                    <span>{{ row.plan_circuit_nurse && row.plan_circuit_nurse.toString() }}</span>
                </div></template
            >
            <template slot="plan_equipment_nurse" slot-scope="{ row }"
                ><div style="width: 60px; white-space: normal">
                    <span>{{ row.plan_equipment_nurse && row.plan_equipment_nurse.toString() }}</span>
                </div></template
            >
        </crud-facecade>
        <el-pagination
            class="align-left"
            background
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="refreshList"
            @current-change="refreshList"
            :page-sizes="[10, 20, 50, 100, 200]"
            :current-page.sync="currentPage"
            :page-size.sync="pageSize"
            :total="total"
        >
        </el-pagination>
        <form-dialog
            title="选择手术间"
            :visible.sync="emergencySurgery.emergencySurgeryVisible"
            :data="emergencySurgery.data"
            :columns="emgrgencySurgeryList2"
            width="30%"
            @confirm="SaveEmgrgencySurgery"
        ></form-dialog>
        <form-dialog
            title="选择手术间"
            :visible.sync="RreoperationView.dialogFormVisible"
            :data="RreoperationView.data"
            :columns="emgrgencySurgeryList"
            width="30%"
            @confirm="reOperation"
        ></form-dialog>
        <form-dialog
            title="选择手术间"
            :visible.sync="RestartOperationView.dialogFormVisible"
            :data="RestartOperationView.data"
            :columns="emgrgencySurgeryList"
            width="30%"
            @confirm="RestartOperation"
        ></form-dialog>
        <form-dialog
            title="选择记录单"
            :visible.sync="LoadOperationView.dialogFormVisible"
            :data="LoadOperationView.data"
            :columns="emgrgencyRecordList"
            width="30%"
            @confirm="LoadOperation"
        ></form-dialog>
        <form-dialog
            title="设置工作站"
            :visible.sync="WorkStationColumnView.dialogFormVisible"
            :data="WorkStationColumnView.data"
            :columns="WorkStationColumn"
            width="30%"
            @confirm="SetWorkStationColumnView"
        ></form-dialog>

        <form-dialog
            title="选择记录单"
            :visible.sync="RLoadOperationView.dialogFormVisible"
            :data="RLoadOperationView.data"
            :columns="emgrgencyRecordList"
            width="30%"
            @confirm="RLoadOperation"
        ></form-dialog>
        <form-dialog
            title="选择记录单模板"
            :visible.sync="LoadRecordView.dialogFormVisible"
            :data="LoadRecordView.data"
            :columns="RecordTemplateLists"
            width="30%"
            @confirm="RLoadRecordView"
        ></form-dialog>
        <el-dialog title="合并手术" :visible.sync="mergeApplyList.dialogFormVisible" class="table-h460" :close-on-click-modal="false" width="90%">
            <crud-facecade
                ref="merge-list"
                :url="mergeApplyList.data"
                :columns="mergeColunmList"
                :buttons="buttons"
                :addButton="{ enabled: false }"
                :updateButton="{ enabled: false }"
                @rowClick="activTargetRow"
            >
                <template slot="filter">
                    <el-col :span="4">
                        <item-input type="datearraw2" v-model="rdate1" :clearable="false" size="mini"></item-input>
                    </el-col>
                </template>
                <div slot="table-title" class="align-left padding5" v-show="mergedRow !== undefined">
                    <b>患者姓名:</b> {{ mergedRow && mergedRow.patient_name }} &nbsp; <b>病历号:</b>{{ mergedRow && mergedRow.visit_no }} &nbsp; <b>性别:</b>{{ mergedRow && mergedRow.sex }} &nbsp;
                    <b>年龄:</b>{{ mergedRow && mergedRow.age }} &nbsp; <b>科室:</b>{{ mergedRow && mergedRow.dic_section }} &nbsp; <b>拟施手术:</b>{{ mergedRow && mergedRow.surgeries }} &nbsp;
                </div>
            </crud-facecade>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelMerge">取 消</el-button>
                <el-button type="primary" @click="merged">确 定</el-button>
            </span>
        </el-dialog>
        <pdf-frame :base64="base64" :visible.sync="pdfvisible" :printVisible2="true" title="麻醉记录单"></pdf-frame>
        <form-dialog :title="overrule.title" :data="overrule.data" :visible.sync="overrule.dialogFormVisible" :columns="overrule.columns" @confirm="confirmCancelSurgery"></form-dialog>
        <!-- 移动设备绑定层 -->
<cus-dialog
  title="选择设备"
  :visible.sync="ControlDevice"
  :isclear="true"
  width="660px"
  @confirm="ConfirmDevice()"
  @clear="ClearDevice()"
  @cancel="ControlDevice=false"
>
   <!-- 可选设备（蓝色） -->
  <div class="group-title blue align-left">可选设备</div>
  <el-row :gutter="10" class="nurse-group">
    <el-col
      v-for="n in mobileDevice"
      :key="n.id"
      :span="4"
    >
      <div
        class="nurse-tag blue"
         :class="{selected: localSelectedDevice.includes(n.id)}"
        @click="toggleNurse(n.id)"
      >
        {{ n.name }}
      </div>
    </el-col>
  </el-row>
  <!-- 未排（黄色） -->
  <div class="group-title yellow align-left">不可选设备</div>
  <el-row :gutter="10" class="nurse-group">
    <el-col
      v-for="n in unmobileDevice"
      :key="n.id"
      :span="4"
    >
      <div
        class="nurse-tag yellow"
      >
        {{ n.name }}
      </div>
    </el-col>
  </el-row>
</cus-dialog>
    </div>
</template>
<script>
import Json5 from 'json5'
import printJs from 'print-js'
import { mapGetters } from 'vuex'
export default {
    name: `AnesthesiaSurgeries`,
    props: {},
    data() {
        let validateLength = (rule, value, callback) => {
            if (this.rejectReasons && this.rejectReasons.length > 0) {
                if (value && value.trim().length < 2) {
                    callback(new Error(`取消理由不能少于2个字符`))
                } else {
                    callback()
                }
            } else {
                if (value && value.trim().length < 4) {
                    callback(new Error(`取消理由不能少于4个字符`))
                } else {
                    callback()
                }
            }
        }
        let that = this
        // 监听页面回传消息
        window.addEventListener(
            `message`,
            event => {
                let d = (_.startsWith(event.data, `{`) && Json5.parse(event.data)) || {}
                if (d.order == `refreshAnesList`) {
                    that.$refs[`surgery-list`] && that.$refs[`surgery-list`].ReloadListData()
                }
            },
            false
        )
        return {
            title: `麻醉列表`,
            surgeryinfopush: this.$root.SurgeryInfoPush,
            url: {
                area: `AnesthesiaSurgeryList`,
                baseURL: `/api`,
                get: paras => {
                    return this.ReloadListData(paras)
                }
            },
            currentPage: 1,
            ControlDevice: false,
            pageSize: 50,
            total: 0,
            datacount: 0,
            buttons: [],
            enable_tagsview: true,
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            activeSurgeryId: this.$route.query.surgery_id,
            surgerSubStringRule: this.$root.SurgerSubStringRule,
            emergencySurgerySelectionHospitalWard: this.$root.EmergencySurgerySelectionHospitalWard,
            isSelectionHospitalWard: `0`,
            isSelectVisitType: `0`,
            activeNames: [],
            isReloadAlive: true,
            searchKey: ``,
            searchKey2: ``,
            surgeries: [],
            rdate: [this.$moment().format(`YYYY/MM/DD`), this.$moment().format(`YYYY/MM/DD`)],
            rdate1: this.$moment().format(`YYYY/MM/DD`),
            rowClass: {},
            dic_room_ids: [],
            mobileDevice: [],
            unmobileDevice: [],
            localSelectedDevice: [], // 弹层多选确定
            chooseRow: undefined,
            isFirst: true,
            emergencySurgery_dic_room_id: undefined,
            surgery_status: [20, 30, 40, 50, 60], // 20
            is_own: false,
            emergencySurgery: {
                emergencySurgeryVisible: false,
                data: {}
            },
            mergeApplyList: {
                dialogFormVisible: false,
                data: {
                    baseURL: `/api/Preoperative/Apply/GetForMergeList`,
                    get: () => {
                        return new Promise((resolve, reject) => {
                            let that = this
                            let req = that.myaxios.get(`/api/Preoperative/Apply/GetForMergeList?date=${this.rdate1}`)
                            req.then(data => {
                                resolve(data)
                            }).catch(e => reject(e))
                        })
                    }
                }
            },
            mergedRow: undefined,
            merged_target_row: undefined,
            reoperationView: {
                dialogFormVisible: false,
                data: { surgeryInfoId: ``, operatingRoomId: `` }
            },
            RestartOperationView: {
                dialogFormVisible: false,
                data: { surgeryInfoId: ``, operatingRoomId: `` }
            },
            LoadOperationView: {
                dialogFormVisible: false,
                data: { surgeryInfoId: ``, in_room_time: ``, lable: `` }
            },
            WorkStationColumnView: {
                dialogFormVisible: false,
                data: { dic_recovery_ward_id: ``, dic_operating_room_id: ``, relation_dic_operating_room_ids: ``, default_printer_name: ``, computer_name: ``, token: `` }
            },
            anesrow: null,
            RLoadOperationView: {
                dialogFormVisible: false,
                data: { surgeryInfoId: ``, in_room_time: ``, lable: `` }
            },
            LoadRecordView: {
                dialogFormVisible: false,
                data: { surgeryInfoId: ``, in_room_time: ``, lable: `` }
            },
            base64: ``,
            pdfvisible: false,
            RecordConfig: [],
            RescueConfig: [],
            RecordConfigLists: [],
            Aconfig: ``,
            is_local_anes: null,
            RreoperationView: {
                dialogFormVisible: false,
                data: { surgeryInfoId: ``, in_room_time: `` }
            },
            isshow: false,
            IsCanPrintAfterArchived: `0`,
            surgeryCancelDialog: {
                visible: false,
                textareaplaceinfo: `请录入取消原因`,
                title: `取消手术`,
                required: true
            },
            applyRejectResons: this.$root.ApplyRejectResons,
            rejectReasons: [],
            overrule: {
                title: `取消手术`,
                dialogFormVisible: false,
                emitBtnName: `cancelSurgery`,
                data: {},
                columns: [
                    {
                        type: `select`,
                        prop: `reject_reason`,
                        label: `取消原因`,
                        config: {
                            allowCreate: true
                        },
                        options: this.rejectReasons,
                        validate: [
                            { validator: validateLength, trigger: `blur` },
                            { required: true, message: `必填项目`, trigger: `blur` }
                        ]
                    }
                ]
            },
            proc_GetTipItemsAnesthsia: this.$root.proc_GetTipItemsAnesthsia,
            anesthesiaListCustomOrder: this.$root.AnesthesiaListCustomOrder,
            defaultSort: { prop: `sequence`, order: `ascending` },
            isEmgrgencyInRoom: this.$root.SaveEmgrgencyInSurgeryList == `0`,
            openAnesthsiaByScan: this.$root.OpenAnesthsiaByScan == `1`,
            currentOperatingWardId: 0,
            currentWorkConfig: null,
            surgeryLoadConfig: (this.$root.SurgeryLoadConfig || `1`) == `1`,
            anesthsiaListExportConfig: this.$root.AnesthsiaListExportConfig && _.includes(this.$root.AnesthsiaListExportConfig.trim().toLowerCase(), `proc_`)
        }
    },
    created() {
        let that = this
        console.log(this.T(`anesthesia_surgery_list.jz_visit_no`) || this.T(`anesthesia_surgery_list.visit_no`))
        // this.$store.dispatch("ADD_OPERATION_WARD_AUTH")
        if (that.anesthesiaListCustomOrder && that.anesthesiaListCustomOrder == `1`) {
            that.defaultSort = {}
        }
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.$store.dispatch(`localip/LOAD_LOCAL_IP`).then(() => {
            that.loadWorkStationConfig().then(() => {
                that.$refs[`surgery-list`] && that.$refs[`surgery-list`].ReloadListData()
            })
        })
        this.loadRejectResons()
        if (that.emergencySurgerySelectionHospitalWard) {
            var arrs = that.emergencySurgerySelectionHospitalWard.split(`|`)
            if (arrs.length > 1) {
                that.isSelectionHospitalWard = arrs[0]
                that.isSelectVisitType = arrs[1]
            } else {
                that.isSelectionHospitalWard = arrs[0]
            }
        }
    },

    computed: {
        ...mapGetters([
            `operation_room_auth`,
            `hospital_ward_auth`,
            `operation_ward_auth_disabled`,
            `operation_ward_auth`,
            `sys_enums`,
            `active_ward`,
            `section_auth`,
            `screenHeight`,
            `sysuser/workers_by_duty`,
            `sysuser/workers_by_dutyNew`,
            `business`,
            `localip/ipAddress`,
            `otherSettingColumn`,
            `extendColumnList`
        ]),
        worker() {
            if (this.isWorkerByDuty == `0`) {
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 175) || 0
        },
        getPlaceholder() {
            return `请扫${this.T(`anesthesia_surgery_list.visit_no`)}`
        },
        isDesktop() {
            return typeof winformMsg != `undefined`
        },
        localIp() {
            return (this[`localip/ipAddress`][0] && this[`localip/ipAddress`][0].value) || `0.0.0.0`
        },
        columnList() {
            let list = [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `custom`,
                    prop: `patient_info`,
                    label: `患者信息`,
                    width: `300`,
                    tooltip: false,
                    isListable: true
                },
                // ACIS-23444 麻醉列表希望可以看到“科室”信息
                {
                    type: `string`,
                    prop: `dic_section`,
                    label: `科室`,
                    width: `100`,
                    isListable: true,
                    sortable: true,
                    queryable: true
                },
                {
                    type: `select`,
                    prop: `dic_section_id`,
                    label: `科室`,
                    searchable: true,
                    queryable: true,
                    options: this[`section_auth`]
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `患者姓名`,
                    width: `100`,
                    isListable: false,
                    searchable: true,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `patient_abbr`,
                    label: `患者姓名简拼`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgery_status`,
                    label: `患者状态`,
                    width: `80`,
                    isListable: false,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`anesthesia_surgery_list.visit_no`),
                    isListable: false,
                    searchable: true,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `sex`,
                    label: `性别`,
                    width: `60`,
                    isListable: false,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    width: `100`,
                    isListable: false,
                    searchable: true,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `dic_inpatient_section`,
                    label: `病区`,
                    width: `120`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_operating_room`,
                    label: `手术间`,
                    width: `120`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `scheduled_sequence`,
                    label: `台次`,
                    width: `60`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `bed_no`,
                    label: `床号`,
                    width: `60`,
                    isListable: false,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `拟施手术`,
                    isListable: true,
                    sortable: true,
                    queryable: true
                },
                {
                    type: `remoteselect`,
                    prop: `q_surgeries`,
                    label: `拟施手术`,
                    options: `/api/AcisSystem/Surgery/Search`,
                    showCount: 3,
                    collapseTags: false,
                    searchable: true,
                    queryable: true,
                    config: { popperAppendToBody: true }
                },
                {
                    type: `custom`,
                    prop: `diseases`,
                    label: `诊断`,
                    width: `200`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `remoteselect`,
                    prop: `q_diseases`,
                    label: `诊断`,
                    width: `100`,
                    searchable: true,
                    collapseTags: false,
                    config: { popperAppendToBody: true },
                    options: `/api/AcisSystem/Disease/Search`
                },
                {
                    type: `remoteselect`,
                    prop: `q_anaes_methods`,
                    label: `麻醉方式`,
                    width: `100`,
                    searchable: true,
                    options: `/api/AcisSystem/AnaesthesiaMethod/Search`
                },
                {
                    type: `custom`,
                    prop: `anaes_methods`,
                    label: `麻醉方式`,
                    width: `100`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `plan_time`,
                    label: `计划手术开始时间`,
                    width: `140`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `custom`,
                    prop: `surgeon`,
                    label: this.T(`anesthesia_surgeries.plan_surgeon`),
                    width: `100`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeon_assistants`,
                    label: this.T(`anesthesia_surgeries.plan_surgeon_assistants`),
                    isListable: false,
                    sortable: true,
                    queryable: true
                },
                {
                    type: `custom`,
                    prop: `plan_anes_doctor`,
                    label: this.T(`anesthesia_surgeries.plan_anes_doctor`),
                    isListable: true,
                    sortable: true,
                    width: `100`
                },
                {
                    type: `remoteselect`,
                    prop: `q_plan_anes_doctor`,
                    label: this.T(`anesthesia_surgeries.plan_anes_doctor`),
                    width: `100`,
                    searchable: true,
                    sortable: true,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.worker && this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            if (this.$root.UseASAeCheck == `1`) {
                                works = works.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        //  code: d.code,
                                        // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                    }
                                })
                            }
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `plan_anes_assistants`,
                    label: this.T(`anesthesia_surgeries.plan_anes_assistants`),
                    isListable: false,
                    queryable: true
                },
                {
                    type: `custom`,
                    prop: `plan_circuit_nurse`,
                    label: this.T(`anesthesia_surgeries.plan_circuit_nurse`),
                    width: `100`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `custom`,
                    prop: `plan_equipment_nurse`,
                    label: this.T(`anesthesia_surgeries.plan_equipment_nurse`),
                    width: `100`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `his_remark`,
                    label: `申请备注`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `his_id`,
                    label: this.T(`his_id`),
                    width: `120`,
                    isListable: true,
                    searchable: true
                },
                {
                    type: `select`,
                    prop: `enum_surgery_type`,
                    label: `手术类型`,
                    width: `80`,
                    queryable: true,
                    searchable: true,
                    options: this.sys_enums.Enum_SurgeryType || []
                },
                {
                    type: `select`,
                    prop: `is_local_anes`,
                    label: `是否局麻`,
                    width: `80`,
                    queryable: true,
                    searchable: true,
                    options: `enum_onetwoint`
                },
                {
                    type: `datetime`,
                    prop: `in_room_time`,
                    label: `入室时间`,
                    width: `140`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `out_room_time`,
                    label: `出室时间`,
                    width: `140`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `enum_asa`,
                    label: `ASA`,
                    isListable: true,
                    sortable: true,
                    options: this.sys_enums.Enum_ASA || []
                },
                {
                    type: `string`,
                    prop: `surgeon_assistants`,
                    label: this.T(`fullcalendar_schedule_surgery.plan_surgeon_assistants`),
                    width: `140`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `anes_assistants`,
                    label: this.T(`fullcalendar_schedule_surgery.plan_anes_assistants`),
                    width: `140`,
                    isListable: true
                }, {
                    type: `custom`,
                    prop: `anes_is_print`,
                    label: `是否已打印`,
                    width: `80`,
                    isListable: true
                }

            ]
            if (this.surgeryinfopush == `true`) {
                list.push({
                    type: `custom`,
                    prop: `push_status`,
                    label: `回传状态`,
                    width: `120`,
                    isListable: true
                })
            }
            // 显示动态扩展列
            list = this.$surgeryInfoExtraParamUtil.SetExtraColumnList(this.extendColumnList, list)

            list.push({
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `160`,
                fixed: `right`,
                isListable: true,
                readonly: false,
                options: (that, { row }) => {
                    let r = [
                        {
                            class: `is-plain is-circle`,
                            label: ``,
                            icon: `el-icon-document`,
                            type: `primary`,
                            emit: `loadAnesthesiaIndex`,
                            permission: `default`,
                            tooltip: `麻醉单`
                        }
                    ]
                    if (row.enum_surgery_status >= 50) {
                        r.push({
                            class: `is-plain is-circle`,
                            label: `苏`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadRecovery`,
                            permission: `default`,
                            tooltip: `复苏单`
                        })
                    }
                    if (row.enum_surgery_status == 20) {
                        r.push({
                            class: `is-plain is-circle`,
                            label: ``,
                            icon: `el-icon-close`,
                            type: `danger`,
                            emit: `loadSurgeryCancel`,
                            permission: `surgery_list:cancel_surgery`,
                            tooltip: `取消手术`
                        })
                    }
                    if (row.enum_surgery_status == 40 || row.enum_surgery_status == 60) {
                        if (row.enum_surgery_type == 1) {
                            r.push({
                                class: `is-plain is-circle`,
                                label: ``,
                                icon: `el-icon-folder-checked`,
                                type: `primary`,
                                emit: `loadMergedPatientData`,
                                permission: `default`,
                                tooltip: `手术合并`
                            })
                        }
                        if (this.isDesktop === true) {
                            r.push({
                                class: `is-plain is-circle`,
                                label: `再`,
                                icon: ``,
                                type: `primary`,
                                emit: `loadReoperation`,
                                permission: `surgery_list:again`,
                                tooltip: `再次手术`
                            })
                        }
                    }
                    // ACIS-23007 调整
                    if (row.enum_surgery_status >= 40) {
                        if (this.isDesktop === false) {
                            r.push({
                                class: `is-plain is-circle`,
                                label: ``,
                                icon: `el-icon-printer`,
                                type: `primary`,
                                emit: `print`,
                                permission: `default`,
                                tooltip: `打印`
                            })
                        }
                    }

                    if (row.enum_surgery_status == 40) {
                        if (this.isDesktop === true) {
                            r.push({
                                class: `is-plain is-circle`,
                                label: `重`,
                                icon: ``,
                                type: `primary`,
                                emit: `loadRestartOperation`,
                                permission: `surgery_list:recall`,
                                tooltip: `重新手术`
                            })
                        }
                    }
                    return r
                },
                config: {
                    align: `flex-start`
                }
            })
            return list
        },
        operationRoom() {
            return (
                (this.active_ward &&
                    this.active_ward.operation_room &&
                    this.active_ward.operation_room.map(d => {
                        d.code = ``
                        return d
                    })) ||
                []
            )
        },
        titleLabel() {
            return function(row) {
                let title = `患者:${row.patient_name} 性别:${row.sex || `--`} 年龄:${row.age || `--`} 
病例号:${row.visit_no || `--`} 
术前诊断:${row.diseases || `--`}
拟施手术:${row.surgeries || `--`}
${this.T(`Schedule.plan_surgeon`)}:${row.surgeon || `--`}
手术科室:${row.dic_section || `--`}
${this.T(`Schedule.plan_anes_doctor`)}:${row.plan_anes_doctor == null ? `` : row.plan_anes_doctor.label}
申请台次:${row.sequence || ``}
申请时间:${this.$moment(row.apply_time).format(`YYYY-MM-DD HH:mm:ss`)}
备注:${row.his_remark || ``}
传染病:${row.infectious || ``}
麻醉类型:${row.is_local_anes_val || ``}
`
                return title
            }
        },
        anesthesia_path() {
            let r = _.find(this.business, { business_level: `M002` })
            return (r && r.url) || `/`
        },
        emgrgencySurgeryList() {
            let list =
                (this.active_ward &&
                    this.active_ward.operation_room &&
                    this.active_ward.operation_room.map(d => {
                        d.code = ``
                        return d
                    })) ||
                []
            return [
                {
                    type: `select`,
                    prop: `JH`,
                    label: `手术间`,
                    options: list,
                    colspan: 24,
                    size: ``,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `reason`,
                    label: `原因`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                }
            ]
        },
        emgrgencySurgeryList2() {
            let list =
                (this.active_ward &&
                    this.active_ward.operation_room &&
                    this.active_ward.operation_room.map(d => {
                        d.code = ``
                        return d
                    })) ||
                []
            let arry = [
                {
                    type: `select`,
                    prop: `JH`,
                    label: `手术间`,
                    options: list,
                    colspan: 24,
                    default: this.emergencySurgery_dic_room_id,
                    size: ``,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                }
            ]
            if (this.isSelectionHospitalWard == `1`) {
                arry.push({
                    type: `select`,
                    prop: `hospitalward_id`,
                    label: `机构`,
                    options: this[`hospital_ward_auth`],
                    colspan: 24,
                    size: ``,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                })
            }
            if (this.$root.OpenPatientInfoQuery && this.$root.OpenPatientInfoQuery == `true`) {
                arry.push({
                    type: `string`,
                    prop: `visit_no`,
                    label: `${this.T(`anesthesia_surgery_list.jz_visit_no`) || `病历号/${this.T(`anesthesia_surgery_list.visit_no`)}`}`
                })
            }
            if (this.isSelectVisitType == `1`) {
                arry.push({
                    type: `select`,
                    prop: `enum_surgery_type`,
                    label: `就诊类型`,
                    colspan: 24,
                    default: 1,
                    options: this.sys_enums.Enum_SurgeryType || [],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                })
            }
            return arry
        },
        emgrgencyRecordList() {
            return [
                {
                    type: `select`,
                    prop: `JLD`,
                    label: `记录单`,
                    options: this.RecordConfig,
                    colspan: 24,
                    size: ``,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                }
            ]
        },
        RecordTemplateLists() {
            return [
                {
                    type: `select`,
                    prop: `JLD`,
                    label: `记录单`,
                    options: this.RecordConfigLists,
                    colspan: 24,
                    size: ``,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                }
            ]
        },
        WorkStationColumn() {
            return [
                {
                    type: `select`,
                    prop: `dic_recovery_ward_id`,
                    label: `所属区域`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    options: (that, { row }) => {
                        let data = _.filter(this.operation_ward_auth_disabled, d => {
                            return d.disabled === false
                        })
                        return data
                    },
                    change: (that, { row }) => {
                        row.dic_operating_room_id = undefined
                    }
                },
                {
                    type: `select`,
                    prop: `dic_operating_room_id`,
                    label: `所在手术间`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    options: (that, { row }) => {
                        let data = _.filter(this.operation_ward_auth_disabled, d => {
                            return d.value == row.dic_recovery_ward_id
                        })
                        return (
                            _.filter(data[0] && data[0].operation_room, d => {
                                return d.disabled === false
                            }) || []
                        )
                    }
                },
                {
                    type: `multiselect`,
                    prop: `relation_dic_operating_room_ids`,
                    label: `关联手术间`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    collapseTags: false,
                    options: (that, { row }) => {
                        let data = _.filter(this.operation_ward_auth_disabled, d => {
                            return d.value == row.dic_recovery_ward_id
                        })
                        return (
                            _.filter(data[0] && data[0].operation_room, d => {
                                return d.disabled === false
                            }) || []
                        )
                    }
                },
                {
                    type: `string`,
                    prop: `default_printer_name`,
                    label: `默认文书打印机`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true
                },
                {
                    type: `string`,
                    prop: `computer_name`,
                    label: `计算机名称`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true
                },
                {
                    type: `string`,
                    prop: `token`,
                    label: `本机IP`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    default: this.localIp,
                    readonly: true
                }
            ]
        },
        mergeColunmList() {
            return [
                {
                    type: `string`,
                    label: `序号`,
                    prop: `id`,
                    isListable: false,
                    isKey: true
                },
                {
                    type: `string`,
                    label: this.T(`anesthesia_surgery_list.visit_no`),
                    prop: `visit_no`,
                    isListable: true
                },
                {
                    type: `string`,
                    label: `姓名`,
                    prop: `patient_name`,
                    isListable: true
                },
                {
                    type: `string`,
                    label: `性别`,
                    prop: `sex`,
                    isListable: true
                },
                {
                    type: `string`,
                    label: `年龄`,
                    prop: `age`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_section`,
                    label: `科室`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `string`,
                    label: `拟施手术`,
                    prop: `surgeries`,
                    isListable: true
                }
            ]
        }
    },
    methods: {
        rowDbclick({ row }) {
            this.loadAnesthesiaIndex({ row })
        },
        loadRejectResons() {
            if (this.applyRejectResons && this.applyRejectResons.trim()) {
                this.rejectReasons = this.applyRejectResons
                    .trim()
                    .split(`,`)
                    .map(x => {
                        return {
                            label: x,
                            value: x
                        }
                    })
                console.log(this.rejectReasons)
            } else {
                this.rejectReasons = []
            }
        },
        print({ row }) {
            let that = this
            let reqConfig = this.myaxios.get(`/api/AcisSystem/RecordConfig/SurgeryInfoMapRecord?surgeryInfoId=${row.id}&recordType=1`)
            reqConfig
                .then(data => {
                    if (!data.is_archived && this.IsCanPrintAfterArchived && this.IsCanPrintAfterArchived == `1`) {
                        this.$message(`麻醉单需要先归档后才能打印`, `info`)
                        return false
                    }

                    let req = this.myaxios.post(`/api/Operation/Home/ExportPdfPrint?surgeryInfoId=${row.id}&recordType=1`)
                    let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                    that.myaxios
                        .all(req, req2)
                        .then(([data, data1]) => {
                            printJs({
                                printable: data,
                                type: `pdf`,
                                base64: true,
                                onPrintDialogClose: () => {
                                    if (data1.value === `true`) {
                                        setTimeout(function() {
                                            that.$confirm(`提示`, {
                                                title: `提示`,
                                                message: `请确认打印是否已完成`,
                                                confirmButtonText: `打印完成`,
                                                cancelButtonText: `打印未完成`,
                                                type: `warning`
                                            })
                                                .then(() => {})
                                                .catch(e => {
                                                    console.log(e)
                                                })

                                            // ElementUI.MessageBox.confirm(`请确认打印是否已完成`, `提示`, {
                                            //     confirmButtonText: `打印完成`,
                                            //     cancelButtonText: `打印未完成`
                                            // })
                                        }, 2000)
                                    }
                                }
                            })
                        })
                        .catch(e => console.log(e))
                })
                .catch(e => {
                    console.log(e)
                })
        },
        ReloadListData(paras) {
            console.log(this.enum_boolint)
            let that = this
            if (that.isFirst) {
                return
            }
            // 更改日期触发更新列表
            let operatingWardId = 0
            let operatingRoomId = []
            let recoveryWardId = 0

            if (that.active_ward && _.startsWith(that.active_ward.value, `ow_`)) {
                operatingWardId = that.active_ward.origion || 0
                operatingRoomId = that.dic_room_ids
                recoveryWardId = 0
            }
            // 选复苏室则只看在当前复苏室的患者
            if (that.active_ward && _.startsWith(that.active_ward.value, `rw_`)) {
                operatingWardId = 0
                operatingRoomId = []
                recoveryWardId = that.active_ward.origion || 0
            }
            paras.begin = that.rdate[0]
            paras.end = that
                .$moment(that.rdate[1])
                .add(1, `days`)
                .format(`YYYY/MM/DD`)
            paras.surgery_status = that.surgery_status
            paras.dic_operating_ward_id = operatingWardId
            paras.dic_operating_room_ids_arr = operatingRoomId
            paras.dic_recovery_ward_id = recoveryWardId
            paras.is_own = this.is_own
            paras.surgeries = paras.q_surgeries && paras.q_surgeries.label
            paras.diseases = paras.q_diseases && paras.q_diseases.label
            paras.anaes_methods = paras.q_anaes_methods && paras.q_anaes_methods.label
            paras.plan_anes_doctor_id = paras.q_plan_anes_doctor && paras.q_plan_anes_doctor.value
            // let paras = {
            //     begin: that.rdate[0],
            //     end: that.$moment(that.rdate[1]).add(1, `days`).format(`YYYY/MM/DD`),
            //     surgery_status: that.surgery_status,
            //     dic_operating_ward_id: operatingWardId,
            //     dic_operating_room_id: operatingRoomId,
            //     dic_recovery_ward_id: recoveryWardId,
            //     keyword: this.searchValue,
            //     is_own: this.is_own
            // }

            console.log(`*******`)
            console.log(paras)
            console.log(`*******end`)
            // let endDay = that
            //     .$moment(that.rdate[0])
            //     .add(1, `years`)
            //     .format(`YYYY/MM/DD`)
            // if (that.$moment(endDay).isBefore(paras.end)) {
            //     this.$message(`请查询一年内数据`)
            //     return
            // }
            return new Promise(resolve => {
                let req = that.myaxios.postpagination(`/api/Operation/Home/GetSurgeryPageNew?pageIndex=${this.currentPage}&pageSize=${this.pageSize}`, paras)
                req.then(res => {
                    this.total = res.count
                    var data = res.data
                    let sk = that.searchKey.toUpperCase()
                    let openAnesthsia = false
                    if (sk.length > 0) {
                        // ACIS-19803 验证手术
                        let patient = _.find(
                            data.sort((a, b) => b.visit_id - a.visit_id),
                            d => {
                                return (d.visit_no && d.visit_no.toUpperCase() == sk) || (d.his_id && d.his_id == sk)
                            }
                        )
                        if (patient && that.dic_room_ids.length > 0 && that.dic_room_ids.indexOf(patient.dic_operating_room_id) == -1) {
                            that.$alert(`<strong>非本手术间患者</strong>`, `核对失败`, {
                                dangerouslyUseHTMLString: true,
                                type: `warning`
                            })
                            return
                        }
                        if (patient && that.openAnesthsiaByScan) {
                            // 直接扫描患者打开麻醉单
                            openAnesthsia = true
                        } else if (patient && !that.openAnesthsiaByScan) {
                            if (that.surgeryLoadConfig && !(patient.plan_time && that.$moment(patient.plan_time).format(`YYYYMMDD`) == that.$moment().format(`YYYYMMDD`))) {
                                this.$alert(`<strong>非今日排程手术患者！</strong>`, `核对失败`, {
                                    dangerouslyUseHTMLString: true,
                                    type: `warning`
                                })
                            } else {
                                if (that.surgeryLoadConfig && that.dic_room_ids.length > 0 && that.dic_room_ids.indexOf(patient.dic_operating_room_id) == -1) {
                                    that.$alert(`<strong>非本手术间今日排程手术患者！</strong>`, `核对失败`, {
                                        dangerouslyUseHTMLString: true,
                                        type: `warning`
                                    })
                                } else if (that.surgeryLoadConfig && `ow_${patient.dic_operating_ward_id}` !== that.active_ward.value) {
                                    that.$alert(`<strong>非本手术区今日排程手术患者！</strong>`, `核对失败`, {
                                        dangerouslyUseHTMLString: true,
                                        type: `warning`
                                    })
                                } else {
                                    that.searchKey2 = ``
                                    that.$alert(
                                        `
                    <div>
                    <div>
                        <span>姓名：${patient.patient_name}</span>&nbsp;&nbsp;
                        <span>${that.T(`anesthesia_surgery_list.visit_no`)}：${patient.visit_no || `--`}</span>&nbsp;&nbsp;
                        <span>性别：${patient.sex || `--`}</span>&nbsp;&nbsp;
                        <span>年龄：${patient.age || `--`}</span>
                    </div>
                    <div>科室：${patient.dic_section || `--`}</div>
                    <div>${that.T(`anesthesia_surgeries.plan_surgeon`)}：${patient.surgeon || `--`}</div>
                    <div>手术部位：${``}</div>
                    <div>术式：${patient.surgeries || `--`}</div>
                    <div>手术间：${patient.dic_operating_room || `--`}</>
                    <div>${that.T(`anesthesia_surgeries.plan_anes_doctor`)}：${patient.anes_doctor || `--`}</div>
                    <div>麻醉方法：${patient.anaes_methods || `--`}</div>
                    </div>
                                `,
                                        `核对成功`,
                                        {
                                            dangerouslyUseHTMLString: true,
                                            callback: action => {
                                                that.loadAnesthesiaIndex({ row: { id: patient.id } })
                                            }
                                        }
                                    )
                                }
                            }
                        } else {
                            that.$message.warning(`暂无该患者信息`)
                        }
                    }

                    let r = _.filter(data, d => {
                        // let  sk = this.searchKey.toUpperCase()
                        let result = true

                        if (result && sk.length > 0) {
                            // result = d.patient_abbr.toUpperCase().indexOf(sk)>-1||d.patient_name.toUpperCase().indexOf(sk)>-1||d.visit_no.toUpperCase().indexOf(sk)>-1
                            result = d.visit_no && d.visit_no.toUpperCase() == sk
                        }
                        return result
                    }).map(d => {
                        d.row_style = { 'color': `black !important` }
                        d.plan_anes_doctor = d.plan_anes_doctor && d.plan_anes_doctor.label
                        d.plan_anes_assistants = d.plan_anes_assistants && d.plan_anes_assistants.length > 0 && d.plan_anes_assistants.map(i => i && i.label).join(`,`)
                        d.plan_circuit_nurse = d.plan_circuit_nurse && d.plan_circuit_nurse.length > 0 && d.plan_circuit_nurse.map(i => i && i.label).join(`,`)
                        d.plan_equipment_nurse = d.plan_equipment_nurse && d.plan_equipment_nurse.length > 0 && d.plan_equipment_nurse.map(i => i && i.label).join(`,`)
                        that.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(that.extendColumnList, d, d)
                        return d
                    })
                    if (that.proc_GetTipItemsAnesthsia) {
                        that.getSurgeryTipItems(r)
                    }
                    this.datacount = r && r.length
                    if (that.searchKey2 && openAnesthsia) {
                        let openrow = r[0]
                        let row = {
                            id: openrow.id,
                            dic_operating_ward_id: openrow.dic_operating_ward_id,
                            dic_operating_room_id: openrow.dic_operating_room_id,
                            in_room_time: openrow.in_room_time,
                            is_day_surgery: openrow.is_day_surgery,
                            visit_no: openrow.visit_no
                        }
                        console.log(row)
                        that.searchKey2 = ``
                        this.loadAnesthesiaIndex({ row })
                    }
                    resolve(r)
                }).catch(e => {
                    console.log(e)
                    resolve([])
                })
            })
        },
        ExportExcel() {
            let that = this
            let paras = {}
            paras.begin = that.rdate[0]
            paras.end = that
                .$moment(that.rdate[1])
                .add(1, `days`)
                .format(`YYYY/MM/DD`)
            paras.surgery_status = that.surgery_status
            paras.dic_operating_room_ids_arr = that.dic_room_ids
            paras.is_own = this.is_own
            console.log(`paras`, paras)
            this.myaxios.post(`/api/Operation/Home/GetSurgeryPageNewForExport`, paras).then(data => {
                if (data.length <= 0) {
                    this.$message.warning(`暂无导出数据`)
                    return
                }
                this.myaxios.export_excel(data, `麻醉列表.xls`)
            })
        },
        loadRecovery({ row }) {
            let that = this
            let req = this.myaxios.post(`/api/AcisSystem/RecordConfig/GetBeforeOpenRecordConfig?surgeryid=${row.id}&recordType=2`)
            req.then(data => {
                if (data) {
                    this.$confirm(`提示`, {
                        title: `提示`,
                        message: this.$createElement(`div`, [this.$createElement(`p`, data), this.$createElement(`p`, `是否继续?`)]),
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        type: `warning`
                    })
                        .then(() => {
                            that.LoadRecoveryOperation(row)
                        })
                        .catch(e => {
                            console.log(e)
                        })
                } else {
                    that.LoadRecoveryOperation(row)
                }
            }).catch(e => {
                console.log(e)
                that.LoadRecoveryOperation(row)
            })
        },
        loadAnesthesiaIndex({ row }) {
            let that = this
            if (!this[`localip/ipAddress`]) {
                this.$error(`未获取到IP地址!`)
                return
            }
            this.anesrow = row
            let r = typeof winformMsg
            if (r != `undefined`) {
                let req = this.myaxios.get(`/api/AcisSystem/WorkstationConfig/Get?token=${this[`localip/ipAddress`]}`)
                req.then(data => {
                    if (data) {
                        that.loadAnesthesiaIndexBody(this.anesrow)
                    } else {
                        this.$confirm(`提示`, {
                            title: `提示`,
                            message: `未获取到工作站信息，即将进行设置工作站！`,
                            confirmButtonText: `确定`,
                            cancelButtonText: `取消`,
                            type: `warning`
                        })
                            .then(() => {
                                console.log(`this.row`, row)
                                that.WorkStationColumnView.dialogFormVisible = true
                                that.WorkStationColumnView.data = {
                                    dic_recovery_ward_id: row.dic_operating_ward_id,
                                    dic_operating_room_id: row.dic_operating_room_id,
                                    relation_dic_operating_room_ids: ``,
                                    default_printer_name: ``,
                                    computer_name: ``,
                                    token: this[`localip/ipAddress`]
                                }
                            })
                            .catch(e => {
                                console.log(e)
                            })
                    }
                })
            } else {
                that.loadAnesthesiaIndexBody(this.anesrow)
            }
        },
        loadAnesthesiaIndexBody(row) {
            // 处理选择记录单弹框
            this.LoadOperationView.data = {
                surgeryInfoId: row.id,
                in_room_time: row.in_room_time
            }
            this.Data(row).then(data => {
                if (data == true) {
                    // eslint-disable-next-line no-undef
                    this.$message(`该手术为局麻手术，请在局麻手术中操作`)
                    return
                }
                let req = this.myaxios.post(`/api/AcisSystem/RecordConfig/GetBeforeOpenRecordConfig?surgeryid=${row.id}&recordType=1`)
                req.then(data => {
                    if (data) {
                        this.$confirm(`提示`, {
                            title: `提示`,
                            message: this.$createElement(`div`, [this.$createElement(`p`, data), this.$createElement(`p`, `是否继续?`)]),
                            confirmButtonText: `确定`,
                            cancelButtonText: `取消`,
                            type: `warning`
                        })
                            .then(() => {
                                // 设置了开启验证，则日间手术没有住院号不能排程
                                this.loadAnesthesia(row)
                            })
                            .catch(e => {
                                console.log(e)
                            })
                    } else {
                        this.loadAnesthesia(row)
                    }
                }).catch(e => {
                    console.log(e)
                    this.loadAnesthesia(row)
                })
            })
        },
        loadAnesthesia(row) {
            let that = this
            if (this.$root.IsCanSchedule && this.$root.IsCanSchedule == `0`) {
                if (row.is_day_surgery && (!row.visit_no || row.visit_no == `-`)) {
                    this.$alert(`${row.patient_name}没有${this.T(`anesthesia_surgery_list.visit_no`)}，不能使用麻醉单`, `提示`, {
                        dangerouslyUseHTMLString: true,
                        type: `warning`
                    })
                    return false
                }
            }
            if (this.Aconfig == `1` && row.in_room_time == null) {
                this.LoadOperationView.dialogFormVisible = true
            } else {
                let req = this.myaxios.get(`/api/AcisSystem/OperatingWard/Get?id=${row.dic_operating_ward_id}`)
                this.myaxios
                    .all(req)
                    .then(([data]) => {
                        if (data && data.allow_select_record_template && row.in_room_time == null) {
                            that.Aconfig = `1`
                            that.LoadOperationView.dialogFormVisible = true
                        } else {
                            that.Aconfig = `0`
                            that.LoadOperation(row)
                        }
                    })
                    .catch(e => {
                        console.log(e)
                    })
            }
            that.refreshList()
        },
        // 取消手术
        loadSurgeryCancel({ row }) {
            this.$confirm(`提示`, {
                title: `提示`,
                message: this.$createElement(`div`, [this.$createElement(`p`, `此操作将取消('${row.patient_name}','${row.visit_no}')的已排程手术`), this.$createElement(`p`, `是否继续?`)]),
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            })
                .then(() => {
                    var col = _.find(this.overrule.columns, c => c.prop == `reject_reason`)
                    if (col) {
                        console.log(this.rejectReasons)
                        if (this.rejectReasons && this.rejectReasons.length > 0) {
                            col.options = this.rejectReasons
                            col.type = `select`
                        } else {
                            col.options = []
                            col.type = `string`
                        }
                    }
                    this.overrule.data = row
                    this.overrule.dialogFormVisible = true
                })
                .catch(e => {
                    console.log(e)
                })
        },
        Data(row) {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/Preoperative/Apply/Get?id=${row.id}`)
                this.myaxios
                    .all(req)
                    .then(([data]) => {
                        resolve(data.is_local_anes)
                    })
                    .catch(e => {
                        console.log(e)
                    })
            })
        },
        LoadRecoveryOperation(row) {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    action: `openRev`,
                    id: row.surgeryInfoId || row.id
                }
                winformMsg.acceptMessage(cefJson)
            } else {
                let req = this.myaxios.post(`/api/Operation/Home/ExportPdf?surgeryInfoId=${row.surgeryInfoId || row.id}&recordType=2`)
                req.then(data => {
                    this.pdfvisible = true
                    this.base64 = data
                }).catch(e => console.log(e))
            }
        },
        SetWorkStationColumnView(row) {
            console.log(`SetWorkStationColumnView`, row)
            let that = this
            return new Promise(resolve => {
                let r = {
                    dic_operating_room_id: row.dic_operating_room_id,
                    relation_dic_operating_room_ids: row.relation_dic_operating_room_ids,
                    default_printer_name: row.default_printer_name,
                    computer_name: row.computer_name,
                    token: row.token
                }
                if (r.dic_operating_room_id == undefined) {
                    this.$message.warning(`手术麻醉工作站手术间不能为空`)
                    return
                }
                let req = this.myaxios.post(`/api/AcisSystem/WorkstationConfig/Post`, r)
                req.then(data => {
                    that.WorkStationColumnView.dialogFormVisible = false
                    this.loadAnesthesiaIndexBody(that.anesrow)
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        LoadOperation(row) {
            let that = this
            let r = typeof winformMsg
            if (r != `undefined`) {
                that.chooseRow = row
                let surid = row.surgeryInfoId || row.id
                // 判断当前手术是否需要选择设备
                let req = this.myaxios.get(`/api/AcisSystem/Device/CheckIsNeedDevice?surgeryInfoId=${row.surgeryInfoId || row.id}`)
                req.then(data => {
                    if (data == `1`) {
                        that.localSelectedDevice = []
                        that.ControlDevice = true
                        // 获取所有的移动设备
                        let req2 = this.myaxios.get(`/api/AcisSystem/Device/GetMobile`)
                        req2.then(devices => {
                            that.mobileDevice = devices.filter(s => s.biz_surgery_info_id == null || s.biz_surgery_info_id == surid)
                            that.unmobileDevice = devices.filter(s => s.biz_surgery_info_id != null && s.biz_surgery_info_id != surid)
                            that.localSelectedDevice = devices.filter(s => s.biz_surgery_info_id == surid).map(i => i && i.id)
                        })
                    } else {
                        var cefJson = {
                            action: `openAnes`,
                            id: surid
                        }
                        winformMsg.acceptMessage(cefJson)
                    }
                }).catch(e => console.log(e))
            } else {
                let req = this.myaxios.post(`/api/Operation/Home/ExportPdf?surgeryInfoId=${row.surgeryInfoId || row.id}&recordType=1`)
                req.then(data => {
                    this.pdfvisible = true
                    this.base64 = data
                }).catch(e => console.log(e))
            }
            this.LoadOperationView.dialogFormVisible = false
            // 创建需要的麻醉单
            if (row.in_room_time == null && row.JLD != null) {
                this.myaxios.post(
                    `/api/AcisSystem/RecordConfig/CreateSurgeryInfoMapRecord?surgeryInfoId=${row.surgeryInfoId || row.id}&FileName=${_.filter(this.RecordConfig, { value: row.JLD })[0].label}`
                )
            }
        },
        /* 弹层内切换选中 */
        toggleNurse(id) {
            const idx = this.localSelectedDevice.indexOf(id)
            idx === -1
                ? this.localSelectedDevice.push(id)
                : this.localSelectedDevice.splice(idx, 1)
        },
        ConfirmDevice() {
            let that = this
            let surid = this.chooseRow.surgeryInfoId || this.chooseRow.id
            this.$confirm(`提示`, {
                title: `提示`,
                message: this.$createElement(`div`, [this.$createElement(`p`, `是否确定绑定当前患者移动设备？`)]),
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            })
                .then(() => {
                    this.myaxios.post(
                        `/api/AcisSystem/Device/PostMobile?biz_surgery_info_id=${surid}`, that.localSelectedDevice
                    ).then(data => {
                        var cefJson = {
                            action: `openAnes`,
                            id: surid
                        }
                        winformMsg.acceptMessage(cefJson)
                        that.ControlDevice = false
                    }).catch(e => console.log(e))
                })
                .catch(e => {
                    console.log(e)
                })
        },
        ClearDevice() {
            let that = this
            let surid = this.chooseRow.surgeryInfoId || this.chooseRow.id
            this.$confirm(`提示`, {
                title: `提示`,
                message: this.$createElement(`div`, [this.$createElement(`p`, `是否确定清除当前患者移动设备绑定？`)]),
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            })
                .then(() => {
                    this.myaxios.post(
                        `/api/AcisSystem/Device/ClearMobile?biz_surgery_info_id=${surid}`
                    ).then(data => {
                        that.ControlDevice = false
                    }).catch(e => console.log(e))
                })
                .catch(e => {
                    console.log(e)
                })
        },
        loadOperationRoom() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                this.emergencySurgery.emergencySurgeryVisible = true
            } else {
                this.$message(`网页端不允许创建急诊手术`, `warning`)
            }
        },
        SaveEmgrgencySurgery(row) {
            let that = this
            let dicOperatingWardId = this.active_ward && this.active_ward.value
            let postdata = {
                dic_operating_ward_id: dicOperatingWardId.substr(dicOperatingWardId.indexOf(`_`) + 1),
                dic_operating_room_id: row.JH,
                source_hospital_ward_id: row.hospitalward_id,
                visit_no: row.visit_no,
                enum_surgery_type: row.enum_surgery_type
            }
            let req = this.myaxios.post(`/api/Preoperative/Apply/PostEmergency`, postdata)
            req.then(data => {
                if (that.isEmgrgencyInRoom) {
                    let row = { id: data, dic_operating_ward_id: postdata.dic_operating_ward_id }
                    this.loadAnesthesiaIndex({ row })
                } else {
                    that.refreshList()
                }
                this.emergencySurgery.emergencySurgeryVisible = false
            }).catch(e => {
                console.log(e)
            })
        },
        loadMergedPatientData({ row }) {
            this.mergedRow = { ...row }
            // if(this.mergedRow === undefined){
            //   this.$message.warning('未选中需要合并的患者')
            //   return
            // }
            // if(this.mergedRow.enum_surgery_type!==1||(this.mergedRow.enum_surgery_status!==40&&this.mergedRow.enum_surgery_status!==60)){
            //   this.$message.warning('只能合并手术结束或苏醒结束的急诊手术')
            //   return
            // }
            // this.$refs["merge-list"].ReloadListData()
            this.mergeApplyList.dialogFormVisible = true
        },
        activTargetRow({ row }) {
            this.merged_target_row = row
        },
        merged() {
            let surgeryDone = this.mergedRow && this.mergedRow.id
            let hisSurgeryId = this.merged_target_row && this.merged_target_row.id
            if (surgeryDone === undefined || hisSurgeryId === undefined) {
                this.$message.warning(`未选择需要合并的患者`)
                return
            }
            let that = this
            this.$confirm(`确定与"${that.merged_target_row.patient_name},${that.merged_target_row.visit_no}"合并信息？合并后将无法撤销`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = that.myaxios.post(`/api/Preoperative/Apply/MergeSurgery?surgeryDone=${surgeryDone}&hisSurgeryId=${hisSurgeryId}`)
                req.then(data => {
                    this.$refs[`surgery-list`].ReloadListData()
                    that.mergeApplyList.dialogFormVisible = false
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        cancelMerge() {
            this.mergeApplyList.dialogFormVisible = false
        },
        loadSurgeries2() {
            this.searchKey2 = this.substringcdata(this.searchKey2)
            this.searchKey = this.searchKey2
            this.$refs[`surgery-list`].ReloadListData()
        },
        substringcdata(inputval) {
            let outval = ``
            if (this.surgerSubStringRule != ``) {
                let rulestr = this.surgerSubStringRule.split(`,`)
                let left = rulestr[0]
                let right = rulestr[1]
                if (left == 0 && right != 0) {
                    outval = inputval.substring(0, right)
                } else if (left != 0 && right != 0) {
                    outval = inputval.substring(left, right)
                } else {
                    outval = inputval
                }
            } else {
                outval = inputval
            }
            return outval
        },
        loadWorkStationConfig() {
            if (!this[`localip/ipAddress`]) return
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/WorkstationConfig/Get?token=${this[`localip/ipAddress`]}`)
                let req1 = this.myaxios.get(`/api/AcisSystem/RecordConfig/GetByType?intType=${1}`)
                let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=AllowSelectRecordTemplate`)
                let req3 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=IsCanPrintAfterArchived`)
                let req4 = this.myaxios.get(`/api/AcisSystem/RecordConfig/GetByType?intType=${22}`)
                let req5 = this.myaxios.get(`/api/AcisSystem/RecordConfig/Get`)
                this.myaxios.all(req, req1, req2, req3, req4, req5).then(([data, data1, data2, data3, data4, data5]) => {
                    let req1 = this.myaxios.get(`/api/AcisSystem/OperatingRoom/Get/${(data && data.dic_operating_room_id) || 0}`)
                    req1.then(d => {
                        let operatingWardId = (d && d.dic_operating_ward_id) || null
                        this.currentOperatingWardId = operatingWardId
                        this.currentWorkConfig = data
                        let activeWardId = (this.active_ward && this.active_ward.origion) || null
                        // 工作站设置的手术区和当前手术区是否相等，相等取工作站设置的手术间id,不同取当前手术区手术间列表第一个
                        if (operatingWardId && operatingWardId > 0 && operatingWardId == activeWardId) {
                            this.dic_room_ids = data && [data.dic_operating_room_id]
                        }
                        resolve()
                    }).catch(e => {
                        console.log(e)
                    })
                    this.emergencySurgery_dic_room_id = (data && data.dic_operating_room_id) || null
                    let list = _.map(data1, d => {
                        return {
                            value: d.id,
                            label: d.file_name,
                            is_delete: d.is_delete
                        }
                    })
                    let list2 = _.map(data4, d => {
                        return {
                            value: d.id,
                            label: d.file_name,
                            is_delete: d.is_delete
                        }
                    })
                    console.log(`data55555555555`, data5)
                    let list3 = _.map(data5, d => {
                        return {
                            value: d.id,
                            label: d.file_name,
                            enum_record_type: d.enum_record_type,
                            is_delete: d.is_delete
                        }
                    })

                    this.RecordConfig = _.filter(list, { is_delete: false })
                    this.RescueConfig = _.filter(list2, { is_delete: false })
                    this.RecordConfigLists = _.filter(list3, { is_delete: false })
                    console.log(`RecordConfig`, this.RecordConfig)
                    console.log(`data5`, this.RecordConfigLists)
                    this.Aconfig = data2.value
                    this.IsCanPrintAfterArchived = data3.value
                    this.isFirst = false
                })
            }).catch(e => {
                console.log(e)
            })
        },
        loadReoperation({ row }) {
            this.$confirm(`提示`, {
                title: `提示`,
                message: this.$createElement(`div`, [this.$createElement(`p`, `患者“${row.patient_name}”“${row.visit_no}”,是否需要再次手术？`)]),
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            })
                .then(() => {
                    this.RreoperationView.data = {
                        surgeryInfoId: row.id,
                        in_room_time: row.in_room_time
                    }
                    this.RreoperationView.dialogFormVisible = true
                })
                .catch(e => {
                    console.log(e)
                })
        },
        reOperation(row) {
            this.RreoperationView.dialogFormVisible = false
            if (this.Aconfig == `1`) {
                this.RLoadOperationView.data = {
                    surgeryInfoId: row.id | row.surgeryInfoId,
                    in_room_time: row.in_room_time,
                    JH: row.JH,
                    reason: row.reason
                }
                this.RLoadOperationView.dialogFormVisible = true
            } else {
                this.RRLoadOperation(row)
            }
        },
        RLoadOperation(row) {
            let req = this.myaxios.put(
                `api/Intraoperative/Anaesthesia/Reoperation_fileName?surgeryInfoId=${row.surgeryInfoId}&&operatingRoomId=${row.JH}&&reason=${row.reason}&&FileName=${
                    _.filter(this.RecordConfig, { value: row.JLD })[0].label
                }`
            )
            req.then(() => {
                this.$refs[`surgery-list`].ReloadListData()
                this.RLoadOperationView.dialogFormVisible = false
            }).catch(e => console.log(e))
        },
        loadAnesTemplateList() {
            this.LoadRecordView.dialogFormVisible = true
        },
        RLoadRecordView(row) {
            console.log(row)
            console.log(this.RecordConfigLists)
            let r = this.RecordConfigLists.find(s => s.value == row.JLD)
            let req = this.myaxios.post(`/api/Operation/Home/ExportPdfTemplate?RecordName=${r.label}&enum_record_type=${r.enum_record_type}`)
            req.then(data => {
                this.pdfvisible = true
                this.base64 = data
            }).catch(e => console.log(e))
            console.log(r)
        },
        RRLoadOperation(row) {
            let req = this.myaxios.put(`api/Intraoperative/Anaesthesia/Reoperation_fileName?surgeryInfoId=${row.surgeryInfoId}&&operatingRoomId=${row.JH}&&reason=${row.reason}&&FileName=${``}`)
            req.then(() => {
                this.$refs[`surgery-list`].ReloadListData()
                this.RLoadOperationView.dialogFormVisible = false
            }).catch(e => console.log(e))
        },
        loadRestartOperation({ row }) {
            this.$confirm(`提示`, {
                title: `提示`,
                message: this.$createElement(`div`, [this.$createElement(`p`, `患者“${row.patient_name}”“${row.visit_no}”,是否需要重新手术？`)]),
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            })
                .then(() => {
                    this.RestartOperationView.data = {
                        surgeryInfoId: row.id | row.surgeryInfoId
                    }
                    this.RestartOperationView.dialogFormVisible = true
                })
                .catch(e => {
                    console.log(e)
                })
        },
        RestartOperation(row) {
            let req = this.myaxios.put(`api/Intraoperative/Anaesthesia/RestartOperation?surgeryInfoId=${row.surgeryInfoId}&operatingRoomId=${row.JH}&reason=${row.reason}`)
            req.then(() => {
                this.$refs[`surgery-list`].ReloadListData()
                this.RestartOperationView.dialogFormVisible = false
            }).catch(e => console.log(e))
        },
        // 取消手术，把状态改成 -1，加日志记录
        confirmCancelSurgery(row) {
            let that = this
            console.log(row)
            try {
                let req = that.myaxios.put(`/api/Preoperative/Schedule/CancelSurgery?surgeryId=${row.id}&reason=${row.reject_reason}`)
                req.then(data => {
                    that.$message.success(`手术取消成功`)
                    this.$refs[`surgery-list`].ReloadListData()
                    that.overrule.dialogFormVisible = false
                })
            } catch (e) {
                that.$message.error(`手术取消失败`)
            }
        },
        refreshList() {
            this.$refs[`surgery-list`].ReloadListData()
        },
        getSurgeryTipItems(r) {
            let that = this
            let req = this.myaxios.post(
                `api/Intraoperative/Anaesthesia/GetSurgeryTipItems`,
                {
                    begin: that.rdate[0],
                    end: that
                        .$moment(that.rdate[1])
                        .add(1, `days`)
                        .format(`YYYY/MM/DD`),
                    surgery_status: that.surgery_status,
                    proc_key: that.proc_GetTipItemsAnesthsia
                },
                null,
                false
            )
            req.then(data => {
                if (r && data && data.length) {
                    _.forEach(r, d => {
                        let surgeryTip = data.filter(i => i.biz_surgeryinfo_id == d.id) || []
                        that.$set(d, `patientInfoTipItemsList`, surgeryTip)
                    })
                    this.$refs[`surgery-list`].AppendListData(r)
                }
            }).catch(e => {
                console.log(e)
            })
        }
    },
    watch: {
        searchKey2: function(newVal, oldVal) {
            if (newVal.length == 0) {
                this.searchKey = newVal
            }
        },
        rdate1: function(newVal, oldVal) {
            this.$refs[`merge-list`].ReloadListData()
        },
        active_ward: function() {
            this.dic_room_ids = []
            let activeWardId = (this.active_ward && this.active_ward.origion) || null
            // 工作站设置的手术区和当前手术区是否相等，相等取工作站设置的手术间id,不同取当前手术区手术间列表第一个
            if (this.currentOperatingWardId > 0 && this.currentOperatingWardId == activeWardId) {
                this.dic_room_ids = this.currentWorkConfig && [this.currentWorkConfig.dic_operating_room_id]
            }
            this.$refs[`surgery-list`].ReloadListData()
        }
    }
}
</script>
<style scoped></style>

<style lang="less">
.surgery-status-tag {
    width: 12px;
    float: left;
    height: 80px;
}
.group-title {
  font-weight: bold;
  margin: 12px 0 6px;
}
.blue { color: #409EFF; }
.yellow { color: #E6A23C; }

.nurse-group {
  margin-bottom: 12px;
}
.nurse-tag {
  padding: 6px 10px;
  margin-bottom: 6px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  border: 1px solid #dcdcdc;
  transition: all .2s;
}
.nurse-tag.selected {
  background: var(--primary-color, #009688);
  color: #fff;
  border-color: var(--primary-color, #009688);
}
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/SurgeryList.vue